import React from "react";

export default function BondingCurveBar({ progress, migrated, showLabel = true, current, remaining, gradSui = 7500 }) {
  // Show progress as SUI raised toward the graduation goal (e.g. 1,000 / 7,500 = 13.3%), so the
  // bar matches the "X / Y SUI" label below it. The backend `progress` field is token-based
  // (needed to trigger on-chain migration) and is kept only as a fallback when SUI data is absent.
  const suiPct = current != null && gradSui > 0 ? (current / gradSui) * 100 : null;
  const pct = migrated ? 100 : Math.min(suiPct != null ? suiPct : (progress || 0) * 100, 100);
  const fmt = (n) => (n ?? 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
  return (
    <div className="w-full" data-testid="bonding-curve-progress-bar">
      {showLabel && (
        <div className="flex items-center justify-between mb-1.5 text-[11px] font-mono">
          <span className="text-muted-foreground uppercase tracking-wider">
            {migrated ? "Migrated" : "Bonding curve"}
          </span>
          <span className={migrated ? "text-[#00E5FF] font-bold" : "text-[#1EC62E] font-bold"}>
            {pct.toFixed(1)}%
          </span>
        </div>
      )}
      <div className="w-full bg-foreground/10 rounded-full h-2.5 border border-white/10 relative p-0.5 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ${migrated ? "" : "bar-fill"}`}
          style={{
            width: `${pct}%`,
            background: migrated ? "linear-gradient(90deg,#00E5FF,#3B82F6,#FF007A)" : undefined,
            boxShadow: migrated ? "0 0 12px rgba(0,229,255,0.6)" : undefined,
          }}
        />
      </div>
      {showLabel && current !== undefined && (
        <div className="flex items-center justify-between mt-1.5 text-[11px] font-mono text-muted-foreground">
          <span>{fmt(current)} / {fmt(gradSui)} SUI</span>
          {!migrated && <span>{fmt(remaining)} SUI to Cetus</span>}
        </div>
      )}
    </div>
  );
}
